import type { TicketTrashMutationResult } from './api/domains/ticketTrash';

/**
 * Meldung nach „Zurückholen" (Prüfbericht Runde 4 N13): grün nur, wenn wirklich etwas zurückkam.
 * Übersprungen wird z. B. ein Ticket, dessen Endlöschung noch ohne Antwort von weclapp ist — dann
 * stand bis dahin trotzdem „Wiederhergestellt" in Grün über dem richtigen Text.
 */
export function restoreNotice(result: Pick<TicketTrashMutationResult, 'restored' | 'message'>): {
  title: string;
  message: string;
  color: 'green' | 'yellow';
} {
  const restored = result.restored ?? 0;
  return restored > 0
    ? { title: 'Wiederhergestellt', message: result.message, color: 'green' }
    : { title: 'Nicht wiederhergestellt', message: result.message, color: 'yellow' };
}
